// extracted by mini-css-extract-plugin
export default {"pulseAnimation":"customLoadingSpinner_pulseAnimation__vqJIt","pulse":"customLoadingSpinner_pulse__S52-X"};